import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

export default function DashboardLayout() {
  return (
    <div className="bg-[#111]">
      <Sidebar />

      <main className="ml-0 md:ml-[280px] min-h-screen overflow-y-auto p-4 md:p-8 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
